(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['__config', '$location', '$window', '$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'UserCustom', '$scope', 'CompanyInfoQuery', 'CompanyCustom', '$rootScope', '$translate', '$localStorage', 'ENV'];

    function NavbarController(__config, $location, $window, $state, Auth, Principal, ProfileService, LoginService, UserCustom, $scope, CompanyInfoQuery, CompanyCustom, $rootScope, $translate, $localStorage, ENV) {
        var vm = this;

        vm.appVersion = 'v2';
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.inProduction = true;
        vm.swaggerDisabled = true;
        vm.showGtag = ENV.ENVIRONMENT === 'production'
        //ProfileService.getProfileInfo().then(function(response) {
        //    vm.inProduction = response.inProduction;
        //    vm.swaggerDisabled = response.swaggerDisabled;
        //});
        vm.__config = __config;
        vm.login = login;
        vm.changeCCkey = changeCCkey;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;
        vm.setCurrentPersonInfo = setCurrentPersonInfo;
        vm.userProfile = null;
        vm.company = null;
        vm.gotoWebSite = gotoWebSite;
        vm.gotoReserwebHelp = gotoReserwebHelp;
        vm.openInbox = openInbox;
        vm.isInboxOpened = false;
        vm.findAppVersion = findAppVersion;
        vm.selectedCompany = null;
        vm.setChatUserInfo = setChatUserInfo;
        vm.openChat = openChat;
        vm.supportButtonClick = supportButtonClick;


        // vm.companies = [{"id":64543,"title":"شم3به شماره ۹","shortTitle":null,"description":"سامانه نوبت دهی خدمات کارگزاری های سازمان ش3به شماره ۹","phoneNumber":"04143334091","activityType":"BUSINESS_CONSULTING","webSiteUrl":null,"keyUrl":"tamin20","settingId":267841,"agreementId":64544,"locationId":71404,"locationInfo":{"id":71404,"title":null,"address":"تهران - میدان انقلاب","mapX":"35.70080152485188","mapY":"51.389923095703125","isActive":null,"countryId":1011,"stateId":1010,"cityId":36174},"tags":[],"agreementInfo":{"id":64544,"rules":null,"agreement":null},"setting":{"id":267841,"settingName":null,"themeSettingInfoId":267842,"notificationSettingId":267839,"financialSettingId":267840,"themeSettingInfo":{"id":267842,"name":null,"logoImageId":null,"albumInfoId":null},"notificationSetting":{"id":267839,"sendBookingConfirmation":"SMS_AND_EMAIL","sendOnCancelBooking":null,"sendOnMoveBooking":null,"sendCustomerReminder":"SMS_AND_EMAIL","reminderTimeInAdvanced":24.0,"sendBookingConfirmationSupplier":"SMS_AND_EMAIL","sendUserRegistrationMessage":"SMS_AND_EMAIL","sendCustomerSatisfactionMessage":"NONE"},"financialSetting":{"id":267840,"taxPercentage":0.0,"hasDiscount":null,"currency":"RIAL","inPlacePayment":true}},"status":"ACTIVE","workingTimes":[],"telegramBotName":null,"telegramBotToken":null,"subscriptionType":null,"customSetting":"{\"servant_label\":\"مشاور\",\"servants_label\":\"مشاوران\",\"servant_list_access_mode\":\"MENU\",\"durationViewMode\":\"HIDE\",\"isClientEmailRequired\":\"TRUE\",\"capacityViewMode\":\"SHOW\"}","domain":null,"hasDedicatedDomain":null,"appVersion":"v2","parentId":null,"companyMode":"PARENT_COMPANY","category":null,"orderNo":null},
        //     {"id":61892,"title":"sh12","shortTitle":null,"description":"سامانه نوبت دهی خدمات کارگزاری های سازمان sh12","phoneNumber":"-","activityType":"OTHER","webSiteUrl":null,"keyUrl":"tamin12","settingId":61902,"agreementId":61893,"locationId":null,"locationInfo":{"id":null,"title":null,"address":null,"mapX":null,"mapY":null,"isActive":null,"countryId":null,"stateId":null,"cityId":null},"tags":[],"agreementInfo":{"id":61893,"rules":null,"agreement":null},"setting":{"id":61902,"settingName":null,"themeSettingInfoId":61903,"notificationSettingId":61900,"financialSettingId":61901,"themeSettingInfo":{"id":61903,"name":null,"logoImageId":64894,"albumInfoId":64896},"notificationSetting":{"id":61900,"sendBookingConfirmation":"SMS_AND_EMAIL","sendOnCancelBooking":null,"sendOnMoveBooking":null,"sendCustomerReminder":"SMS_AND_EMAIL","reminderTimeInAdvanced":24.0,"sendBookingConfirmationSupplier":"NONE","sendUserRegistrationMessage":"SMS_AND_EMAIL","sendCustomerSatisfactionMessage":"SMS_AND_EMAIL"},"financialSetting":{"id":61901,"taxPercentage":0.0,"hasDiscount":null,"currency":"RIAL","inPlacePayment":true}},"status":"ACTIVE","workingTimes":[],"telegramBotName":null,"telegramBotToken":null,"subscriptionType":null,"customSetting":"{\"parentId\":\"3258294\"}","domain":null,"hasDedicatedDomain":null,"appVersion":null,"parentId":64543,"companyMode":null,"category":"AGENT","orderNo":null}]

        document.addEventListener('goftino_ready', function (evt) {
            vm.chatIsReady = true;
        });

        var cckey = $location.search().cckey;

        function changeCCkey(companyUrl) {

            cckey = companyUrl;
            changeCurrentCompany();
            $window.location.reload();
        }

        function changeCurrentCompany() {
            if (cckey) {
                CompanyCustom.changeCurrentCompany(cckey).query(function (c) {

                    setCurrentCompany();

                });
            }

        }

        // function changeCurrentCompany(key)
        // {
        //     if(key)
        //         cckey = key;
        //     changeCurrentCompany();
        // }


        setDefaultsForWeDoMeet();
        setCurrentPersonInfo();
        setCurrentCompany();

        function login() {
            collapseNavbar();
            LoginService.open();

        }

        function logout() {
            collapseNavbar();
            Auth.logout();

            $('.navbar-fixed-top').removeClass('compact');
            $('#sidebar').removeClass('open');
            $('#menuHamburgerDesktop').removeClass('change');
            $('.navbar-fixed-top').removeClass('compact');
            $('#page-wrapper').removeClass('compact');
            vm.company = null;
            vm.companies = null;
            vm.userProfile = null;

            $state.go('home');

        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function setCurrentPersonInfo() {
            if (Principal.isAuthenticated()) {
                UserCustom.getCurrentUserProfile().query(function (up) {
                    vm.userProfile = up
                });

                vm.companies = UserCustom.getCurrentUserCompanies().query();
            }
        }

        function setCurrentCompany() {
            if (Principal.isAuthenticated()) {

                CompanyInfoQuery.getCurrentCompanyInfo().query(function (c) {

                    vm.company = c;

                    vm.company = c;
                    if (c && c.appVersion && c.appVersion == 'v3') {
                        vm.appVersion = 'v3'
                    }

                    vm.selectedCompany = vm.company;
                    Principal.setCurrentCompany(vm.company);
                    Principal.getCurrentCompanyFeatureList();

                });


            }
        }

        function openInbox() {
            vm.isInboxOpened = true;
        }

        function gotoWebSite() {
            if (vm.company != null && vm.company.keyUrl != null && vm.company.keyUrl != undefined) {
                window.open('http://' + vm.company.keyUrl + '.' + vm.__config.domain, '_blank');
            } else {
                if (Principal.isAuthenticated()) {

                    CompanyInfoQuery.getCurrentCompanyInfo().query(function (c) {

                        vm.company = c;
                        vm.selectedCompany = vm.company;

                        window.open('http://' + vm.company.keyUrl + '.' + vm.__config.domain, '_blank');
                    });


                }
            }
        }

        function gotoReserwebHelp() {

            var helpUrl = getHelpUrl();
            window.open(helpUrl, '_blank');
        }

        function getHelpUrl() {
            if (vm.__config.appMode == 'reserve') {
                return "https://planovin.com/help";
            }
            if (vm.__config.appMode == 'event')
                return "https://wedomeet.ir/help";
        }

        function findAppVersion() {

            collapseNavbar();
            if (vm.company != null && vm.company.appVersion == 'v2') {
                $state.go('supplierPanel.calendar', {stateParamKey: null});
            } else {
                $state.go('supplierPanel.timeBoard', {stateParamKey: null});
            }


        }

        function setDefaultsForWeDoMeet() {
            $translate.use('en');
            $localStorage.appMode = 'reserve';

            if (vm.__config.appMode == 'event') {
                $translate.use('zu');
                $localStorage.appMode = 'event';
            }
            // else{
            //     if(vm.__config.appName && vm.__config.appName =="planovin")
            //     {
            //         $translate.use('pl');
            //         $localStorage.appMode = 'reserve';
            //     }
            // }


        }

        function supportButtonClick() {
            Goftino.toggle();
            setChatUserInfo();
        }

        function setChatUserInfo() {

            if (!vm.chatIsReady)
                return;
            if (!vm.userProfile)
                return;
            if (!vm.userProfile.personInfo)
                return;

            var email = 'no@Email';
            if (vm.userProfile.personInfo.email)
                email = vm.userProfile.personInfo.email;
            var fullName = vm.userProfile.personInfo.fisrtName + ' ' + vm.userProfile.personInfo.lastName;
            var company = vm.selectedCompany.title + ' - ' + vm.selectedCompany.keyUrl;
            var phoneNumber = '111111';
            if (vm.userProfile.personInfo.phoneNumber)
                phoneNumber = vm.userProfile.personInfo.phoneNumber;


            Goftino.setUser({
                email: email,
                name: fullName,
                about: company,
                phone: phoneNumber,
                forceUpdate: true
            });


        }

        function openChat() {
            Goftino.toggle();
            setChatUserInfo();
        }

        $scope.$watch(function () {
            return cckey;
        }, function () {
            changeCurrentCompany();
        });
        $scope.$watch(function () {
            return Principal.isAuthenticated();
        }, function () {
            setCurrentPersonInfo();
            setCurrentCompany();


        });

        //$scope.$watch(function() {
        //    return Principal.getCurrentCompany();
        //}, function() {
        //    setCurrentCompany();
        //});
    }
})();
